import React from "react";
import { Link } from "react-router-dom";
import "./Main.css";
import services from "../../data/serviceData";

const Main = () => {
  return (
    <section className="services-section">
      <div className="services-container">
        <div className="services-heading">
          <span>OUR SERVICES</span>
          <h2>Engineering Expertise Across Industries</h2>
          <p>
            Delivering precision-driven engineering, construction and consultancy
            services across diverse sectors.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div className="service-card" key={service.id}>
              <span className="service-number">{service.id}</span>

              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>

              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.desc}</p>

                <Link to={`/services/${service.slug}`} className="service-btn">
                  Read More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Main;
